import { ShowWithTixologiEvent } from "@punchup/data/legacy/shows";
import { UseQueryResult } from "@tanstack/react-query";
import { useMemo } from "react";
import { useShowsWithTixologiEvents } from "./useShowsWithTixologiEvents";

export function useShowWithTixologiEvent(
  showId: string | undefined
): UseQueryResult<ShowWithTixologiEvent | null> {
  const showIds = useMemo(() => (showId ? [showId] : undefined), [showId]);
  const query = useShowsWithTixologiEvents(showIds);
  // Adapt the array result to a single-item result. `data` stays undefined
  // while loading; once the query resolves we return the show or null when
  // the lookup didn't find one. The `unknown` cast is needed because spreading
  // a discriminated query result preserves the array element type on `refetch`.
  return {
    ...query,
    data: query.data ? (query.data[0] ?? null) : undefined,
  } as unknown as UseQueryResult<ShowWithTixologiEvent | null>;
}
